@if(packages?.initialPlannedSteps > 0){
<div>

	<h3>{{'Treatment packages' | translate}}</h3>

	<div class="packages-container">
		<!-- Closed packages -->
		@for (closed_package of packages.closed; track $index) {
		<div class="package delivered">
			{{"Package" | translate}} {{$index + 1}} ({{ closed_package.steps }})
		</div>
		}
		<!-- Active packages -->
		@if(packages.active){
		<div class="package active">
			{{"Package" | translate}} {{packages.closed.length + 1}} ({{ packages.active.steps }})
		</div>
		}
		<!-- Pending packages -->
		@for (pending_package of packages.pending; track $index) {
		<div class="package">
			{{"Package" | translate}} {{$index + 1 + packages.closed.length +
				( packages.active ? 1: 0)}} ({{ pending_package.steps }})
		</div>
		}
	</div>
</div>
}
